// src/resources/chats.js

import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField, 
    DateField, 
    Show, 
    SimpleShowLayout, 
    useRecordContext,
    ArrayField 
} from 'react-admin';
import { Box, Typography, Avatar, Paper } from '@mui/material';

// --- Chat List (القائمة - كما هي) ---
export const ChatList = (props) => (
    <List {...props} sort={{ field: 'createdAt', order: 'DESC' }}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="id" label="Chat ID" />
            <TextField source="other_participants" label="Participants" />
            <DateField source="createdAt" showTime label="Created At" />
            <TextField source="last_message_preview" label="Last Message" />
        </Datagrid>
    </List>
);

// --- مكون مخصص لعرض سجل الرسائل بالكامل ---
const MessagesIterator = () => {
    const record = useRecordContext();
    
    // حماية: إذا لم يتم تحميل السجل أو لا توجد رسائل
    if (!record || !record.messages || !Array.isArray(record.messages)) {
        return <Typography p={2}>No messages found.</Typography>;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', mt: 2 }}>
            {record.messages.map((msg, index) => {
                const isAudio = msg.type === 'audio';
                // التحقق من وجود المستخدم، وإلا استخدام "Unknown"
                const userName = msg.user ? msg.user.name : 'Unknown';
                const userImage = msg.user ? msg.user.profileImage : null;
                
                return (
                    <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        {/* رأس الرسالة: الصورة والاسم */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5, ml: 1 }}>
                            <Avatar 
                                src={userImage} 
                                alt={userName} 
                                sx={{ width: 24, height: 24, mr: 1 }}
                            />
                            <Typography variant="caption" sx={{ fontWeight: 'bold', mr: 1, color: 'text.secondary' }}>
                                {userName}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                                {new Date(msg.createdAt).toLocaleString()}
                            </Typography>
                        </Box>

                        {/* جسم الرسالة (الفقاعة) - فرض الألوان بقوة */}
                        <Paper 
                            elevation={2} 
                            sx={{ 
                                p: 2, 
                                maxWidth: '80%', 
                                borderRadius: '0px 15px 15px 15px', // شكل فقاعة
                                backgroundColor: '#ffffff !important', // خلفية بيضاء دائماً
                                border: '1px solid #e0e0e0'
                            }}
                        >
                            {isAudio ? (
                                <audio controls src={msg.content} style={{ maxWidth: '100%' }}>
                                    Your browser does not support the audio element.
                                </audio>
                            ) : (
                                <Typography 
                                    variant="body1" 
                                    sx={{ 
                                        color: '#000000 !important', // نص أسود دائماً (Overrides Dark Mode)
                                        fontWeight: '500'
                                    }}
                                >
                                    {msg.content || '---'} 
                                </Typography>
                            )}
                        </Paper>
                    </Box>
                );
            })}
        </Box>
    );
};

// --- Chat Show (صفحة التفاصيل) ---
export const ChatShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            {/* معلومات الشات العلوية */}
            <Box sx={{ mb: 3, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
                <Typography variant="h6" gutterBottom>Conversation Details</Typography>
                <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 1 }}>
                    <Typography variant="subtitle2" color="text.secondary">Chat ID:</Typography>
                    <TextField source="id" />
                    
                    <Typography variant="subtitle2" color="text.secondary">Created:</Typography>
                    <DateField source="createdAt" showTime />
                </Box>
                
                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle2" gutterBottom>Members:</Typography>
                    <ArrayField source="members">
                        <Datagrid bulkActionButtons={false} sx={{ '& .RaDatagrid-headerCell': { display: 'none' } }}>
                            <TextField source="user.name" />
                            <TextField source="user.email" />
                            <TextField source="user.phone" />
                        </Datagrid>
                    </ArrayField>
                </Box>
            </Box>

            <Typography variant="h6">Messages History</Typography>
            
            {/* استخدام المكون المخصص بدلاً من ArrayField التقليدي */}
            <MessagesIterator />

        </SimpleShowLayout>
    </Show>
);